/* eslint-disable react/jsx-props-no-spreading */
import Button, { ButtonProps, ButtonType } from "../Button/Button";
import Link, { LinkProps, LinkType } from "../Link/Link";

interface PageTitleProps {
  title: string;
  description: string;
  leftButton?: Omit<ButtonProps, "type" | "size">;
  rightButton?: Omit<ButtonProps, "type" | "size">;
  linkButton?: Omit<LinkProps, "type">;
}

const PageTitle = ({
  title, description, leftButton, rightButton, linkButton,
}: PageTitleProps) => (
  <div className="flex w-[940px] md:w-[768px] sm:w-[374px] px-20 md:px-6 sm:px-4 justify-between">
    <div className="flex flex-col gap-1">
      <h1 className="text-text-base">{title}</h1>
      <span className="typography-medium-base text-text-subtle">{description}</span>
    </div>
    <div className="flex gap-2">
      {leftButton && <Button {...leftButton} type={ButtonType.primary} size="small" />}
      {rightButton && <Button {...rightButton} type={ButtonType.neutral} size="small" />}
      {linkButton && <Link {...linkButton} type={LinkType.interactive} />}
    </div>
  </div>
);

export default PageTitle;
